import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { NavMarker } from 'react-rhumb';
import { Step } from 'signup-constants/Step';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { EmailDataInput } from './EmailDataInput';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService,
    shouldShowSignInButton,
    emailSignupEnabled
  } = getFlowConfig();
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  useExperiment(ExperimentKeys.ACQ0170, TrackWhen.enrolled);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0177, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0175, TrackWhen.enrolled);
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const isAssignedToACQ173Variants = isAssignedToACQ173VariantA || isAssignedToACQ173VariantC;
  const Footer = () => {
    if (isInstanceOfSignupEmbedder) {
      return /*#__PURE__*/_jsx(Text, {
        as: "div",
        marginBlock: "300",
        textAlign: "center",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(PrivacyBanner, {})
      });
    }
    if (isTrellisThemeEnabled) {
      return /*#__PURE__*/_jsxs(View, {
        marginInline: "auto",
        maxInlineSize: "420px",
        paddingInline: "500",
        textAlign: "left",
        children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      "data-test-id": `${stepKey}-container`,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [/*#__PURE__*/_jsx(LandingPageTitle, {
          isAssignedToACQ173Variants: isAssignedToACQ173Variants,
          isMobile: isMobile
        }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
          $layoutType: layoutType,
          $shouldRestrictWidth: true,
          children: [/*#__PURE__*/_jsx(OAuthSignupSection, {
            shouldShowSeperator: emailSignupEnabled
          }), emailSignupEnabled && /*#__PURE__*/_jsx(EmailDataInput, {}), /*#__PURE__*/_jsx(Footer, {}), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "500",
            textAlign: "center",
            children: shouldShowSignInButton && /*#__PURE__*/_jsx(HaveAnAccountLink, {})
          })]
        })]
      })
    })
  });
};
export default LandingPageView;